import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';

const AIFinalCTA = () => {
  const { language } = useLanguage();

  const content = {
    en: {
      title: "Ready to Create Your Audio Summary?",
      description: "Join thousands of professionals who save time with our advanced AI-powered audio summary generator and intelligent transcription tool. Start creating perfect professional audio summary reports with instant analysis and comprehensive insights for free today!",
      subtitle: "No credit card required • 100% free • Instant results"
    },
    ar: {
      title: "هل أنت مستعد لإنشاء ملخص صوتي؟",
      description: "انضم إلى آلاف المحترفين الذين يوفرون الوقت مع مولد الملخص الصوتي المتقدم المدعوم بالذكاء الاصطناعي وأداة النسخ الذكية. ابدأ في إنشاء تقارير ملخص صوتي مهنية مثالية مع تحليل فوري ورؤى شاملة مجاناً اليوم!",
      subtitle: "لا حاجة للتسجيل • مجاني 100% • نتائج فورية"
    }
  };

  const currentContent = content[language];

  return (
    <div className="container-fluid mb-5" style={{ 
      background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)', 
      padding: '80px 0' 
    }}>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-8 text-center">
            <h2 className="fw-bold mb-4" style={{ color: '#1e293b', fontSize: '2.5rem' }}>
              {currentContent.title}
            </h2>
            <p className="lead mb-5" style={{ color: '#64748b', fontSize: '1.2rem' }}>
              {currentContent.description}
            </p>
            
            {/* Feature Cards */}
            <div className="row mb-5">
              <div className="col-md-4 mb-3">
                <div className="d-flex flex-column align-items-center">
                  <div className="bg-primary rounded-circle d-flex align-items-center justify-content-center mb-3" 
                       style={{ width: '60px', height: '60px' }}>
                    <i className="fas fa-credit-card text-white"></i>
                  </div>
                  <h6 className="fw-bold mb-2" style={{ color: '#1e293b' }}>
                    {language === 'ar' ? 'لا حاجة لبطاقة ائتمان' : 'No credit card required'}
                  </h6>
                </div>
              </div>
              
              <div className="col-md-4 mb-3">
                <div className="d-flex flex-column align-items-center">
                  <div className="bg-primary rounded-circle d-flex align-items-center justify-content-center mb-3" 
                       style={{ width: '60px', height: '60px' }}>
                    <i className="fas fa-zap text-white"></i>
                  </div>
                  <h6 className="fw-bold mb-2" style={{ color: '#1e293b' }}>
                    {language === 'ar' ? 'مجاني 100%' : '100% free'}
                  </h6>
                </div>
              </div>
              
              <div className="col-md-4 mb-3">
                <div className="d-flex flex-column align-items-center">
                  <div className="bg-primary rounded-circle d-flex align-items-center justify-content-center mb-3" 
                       style={{ width: '60px', height: '60px' }}>
                    <i className="fas fa-bolt text-white"></i>
                  </div>
                  <h6 className="fw-bold mb-2" style={{ color: '#1e293b' }}>
                    {language === 'ar' ? 'نتائج فورية' : 'Instant results'}
                  </h6>
                </div>
              </div>
            </div>
            
            {/* CTA Buttons */}
            <div className="d-flex flex-column flex-md-row justify-content-center gap-3">
              <Link 
                to="https://audiosum.app/signup" 
                target="_blank" 
                rel="noopener"
                className="btn btn-primary btn-lg px-5 py-3"
                style={{ 
                  fontSize: '1.1rem',
                  borderRadius: '50px',
                  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                  border: 'none',
                  boxShadow: '0 8px 30px rgba(102, 126, 234, 0.3)'
                }}
              >
                <i className="fas fa-rocket me-2"></i>
                {language === 'ar' ? 'ابدأ مجاناً' : 'Start Free'}
              </Link>
              
              <Link 
                to="https://audiosum.app/upload" 
                target="_blank" 
                rel="noopener"
                className="btn btn-outline-primary btn-lg px-5 py-3"
                style={{ 
                  fontSize: '1.1rem',
                  borderRadius: '50px',
                  borderWidth: '2px'
                }}
              >
                <i className="fas fa-upload me-2"></i>
                {language === 'ar' ? 'ارفع ملف' : 'Upload File'}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AIFinalCTA;